import request from '@/utils/request/index';
import { LoginParams } from './model/userModel';
import { getRefreshToken, getToken } from '@/utils/auth';
/**
 * @description 登录
 */
export function loginApi(data: LoginParams) {
  return request({
    url: '/dt/portal/account/v1/login',
    method: 'post',
    data: {
      codeChannel: 'sms',
      loginType: 'phoneAndVCode',
      phone: data.phone,
      verificationCode: data.code,
    },
  });
}
/**
 * @description 发送验证码
 */
export function sendCode(phone: string) {
  return request({
    url: '/dt/portal/verification-code/v1/send',
    method: 'post',
    data: {
      channel: 'sms',
      phone,
      scene: 'login',
    },
  });
}
/**
 * @description 获取用户信息
 */
export function getUserinfo(archiveId) {
  const params = {
    archiveId,
  };
  return request({
    url: '/dt/portal/account/v1/profile',
    method: 'get',
    params,
  });
}
/**
 * @description 退出登录
 */
export function logoutApi() {
  return request({
    url: '/dt/portal/account/v1/logout',
    method: 'get',
  });
}
/**
 * @description 刷新token
 */
export function updateTokenApi() {
  return request({
    headers: {
      Authorization: getToken(),
    },
    url: '/dt/portal/account/v1/refresh-token',
    method: 'get',
    params: {
      token: getRefreshToken(),
    },
  });
}
/**
 * @description 对比系统版本
 */
export function compareVersionApi() {
  return request({
    headers: {
      Authorization: getToken(),
    },
    url: '/dt/portal/system/v1/latest-version',
    method: 'get',
  });
}
/**
 * @description 删除账户发送验证码
 */
export function sendDeleteAccountSMSApi(bizId: string) {
  return request({
    headers: {
      Authorization: getToken(),
    },
    url: '/dt/portal/verification-code/v1/sendByBizType',
    method: 'post',
    data: {
      scene: 'deleteCurrentAccount',
      channel: 'sms',
      bizId,
    },
  });
}
/**
 * @description 确认删除账户
 */
export function deleteAccountApi(code: string) {
  return request({
    headers: {
      Authorization: getToken(),
    },
    url: '/dt/portal/account/v1/cancel',
    method: 'delete',
    data: {
      codeChannel: 'sms',
      verificationCode: code,
    },
  });
}
